import {  } from './homeblobs.js';
import { calculateReadTime, toc } from './blog.js';
import { accordion, tabs } from './tabs.js';
import { upArrow, setOffsetHeight, textImageEffect1, staggeredAnimation } from './animations.js';
import {} from './mobileNavigation.js';

// homepage();
upArrow();
setOffsetHeight();
textImageEffect1();
staggeredAnimation();
accordion();
tabs();
// execute only when body has class .post-template-default 
if (document.body.classList.contains('post-template-default')) {
    //wait on pageload to calculate readtime and create table of contents
    document.addEventListener('DOMContentLoaded', function () {
        calculateReadTime();
        toc();
    });
}

// Blok niet aanklikbaar maken van teamlid waar nog geen content voor is
// const teamList = document.querySelector('.ajax_medewerkers_content');
// const teamLidEelco = teamList.getElementsByTagName('li')[4];
// const teamLidErwin = teamList.getElementsByTagName('li')[5];
// const teamLidNikki = teamList.getElementsByTagName('li')[14];
// const teamLidPatrick = teamList.getElementsByTagName('li')[15];

// [teamLidEelco, teamLidErwin, teamLidNikki, teamLidPatrick].forEach(member => {
//   member.addEventListener('click', function(event) {
//     event.preventDefault(); // Voorkom dat klikken werkt op deze teamleden
//   });
// });




//Hiermee stellen we een CSS variabele in, aan de bovenkant van de pagina. Hierdoor is de offset bovenaan de pagina correct.
// De scroll-padding staat dan in de CSS GLOBAL.SCSS: 
const navigationHeight = document.querySelector('header.wp-block-template-part').offsetHeight;
// console.log(navigationHeight);
document.documentElement.style.setProperty('--scroll-padding', navigationHeight - 1 + 'px');

// Om op de pagina te blijven moet de modal van de pagina af bij mobiel gebruik:
// const navigationlinks = document.querySelectorAll('.wp-block-navigation-item__content');
// navigationlinks.forEach(function () {
//     let modal = document.querySelector('wp-block-navigation__responsive-container');
//     modal.classList.remove('is-menu-open has-modal-open')
// });

